import { func } from "prop-types"
import { useTranslation } from "react-i18next";
import { Dialog } from "@components";
import { Button, Link } from "@material-ui/core";
import { BILLING_EMAIL } from "@utils";

export const FreePlanChangeDialog = ({ onClose }) => {
  
  const { t } = useTranslation();
  
  return (
    <Dialog
      open
      onClose={onClose}
      title={t("views.subscription.plan.change_to_free.title")}
      actions={
        <Button
          variant="contained"
          color="primary"
          onClick={onClose}
        >
          {t("common.ok")}
        </Button>
      }
    >
      <p>
        {t("views.subscription.plan.change_to_free.content")}
        <Link href={`mailto:${BILLING_EMAIL}`}>
          {BILLING_EMAIL}
        </Link>
      </p>
    </Dialog>
  )
}

FreePlanChangeDialog.propTypes = {
  onClose: func
}